import React from "react";

const NetWork = () => {
  return <div>NetWork</div>;
};

export default NetWork;
